import React from 'react';
import './header-navigation.scss';

import PropTypes from 'prop-types';
import classNames from 'classnames';
import menuItemShape from '../menu-item-shape';

const HeaderNavigation = ({
  items,
  className,
}) => (
  <nav className={classNames('header-navigation', className)}>
    <ul className="header-navigation__list">
      {items.map(menuItem => (
        <li key={menuItem.href}>
          <a
            className="header-navigation__link"
            href={menuItem.href}
            onClick={menuItem.onClick}
          >
            {menuItem.label}
          </a>
        </li>
      ))}
    </ul>
  </nav>
);

HeaderNavigation.propTypes = {
  items: PropTypes.arrayOf(menuItemShape),
  className: PropTypes.string,
};

HeaderNavigation.defaultProps = {
  items: [],
  className: undefined,
};

export default HeaderNavigation;
